import ChildrenEntities from 'client/components/core/ChildrenEntities'
import {
  managementSelectors,
  pageSelectors,
  useManagement,
  usePage,
} from 'client/store/index'
import CommonCarousel from 'common/components/entities/Carousel'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import CarouselInterface, {
  CarouselItemInterface,
} from 'common/types/entities/CarouselInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import React from 'react'
import { generateId } from 'src/shared/entities/utils/generate-base-entity'
import BaseEntity from '../../core/BaseEntity/BaseEntityNew'
import CarouselSlide from './CarouselSlide'

type CarouselProps = {
  entity: CarouselInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function Carousel({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: CarouselProps) {
  const carouselActiveSlideNumber = useManagement(management =>
    managementSelectors.getEntityInnerItemActiveIndex(management, entity.id),
  )
  const carouselItems = usePage(page =>
    pageSelectors.getChildrenEntities(page, entity.childIds),
  )

  return (
    <BaseEntity
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonCarousel
        arrowsColor={entity.arrowsColor}
        controlsColor={entity.controlsColor}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        totalItems={entity.childIds.length}
        htmlAttrId={entity.htmlAttrId}
        activeSlideIndex={carouselActiveSlideNumber}
        showArrows={entity.showArrows}
        mobileShowArrows={entity.mobileShowArrows}
      >
        {carouselItems.map(
          (carouselSlideEntity: CarouselItemInterface, index: number) => (
            <CarouselSlide
              key={carouselSlideEntity.id}
              activeSlideIndex={carouselActiveSlideNumber}
              alignSelf={entity.verticalAlignment}
              mobileAlignSelf={entity.mobileVerticalAlignment}
              slideIndex={index}
            >
              <ChildrenEntities
                id={carouselSlideEntity.id}
                isReadOnly={carouselSlideEntity.isReadOnly}
                type={carouselSlideEntity.type}
                childIds={carouselSlideEntity.childIds}
                placeholderText="entities.carousel.empty_dropbox_text"
              />
            </CarouselSlide>
          ),
        )}
      </CommonCarousel>
    </BaseEntity>
  )
}

export function createCarouselItem(
  parentId: string,
  masterBlockId?: MasterBlockId,
  creationItemNumber = 1,
): CarouselItemInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.CarouselItem,
    creationItemNumber: creationItemNumber,
    parentId: parentId,
    masterBlockId: masterBlockId,
    childIds: [],
  }
}

export default Carousel
